export default __webpack_public_path__ + "static/0286-f01915fe3d47924ab17294960c1d2789.png";